
import { useBlockProps } from '@wordpress/block-editor';
export default function save( { attributes } ) {
	const {
		progressName,
		percentage,
		fillColor,
		trackColor,
		showPercentage,
		progressHeight,
		textColor,
		percentageTextColor,
		textFontSize,
		percentageFontSize,
		textFontFamily,
		percentageFontFamily,

	} = attributes;

	const blockProps = useBlockProps.save();



	return (
		<div { ...blockProps }>
			{ ( progressName ) && (
				<div
					className="progress-name"
					style={ {
						color: textColor,
						fontSize: `${ textFontSize }px`,
						fontFamily: textFontFamily,
					} }
				>
					
					{ progressName }
				</div>
			) }
			<div
				className="progress-track"
				style={ {
					backgroundColor: trackColor,
					height: `${ progressHeight }px`,
				} }
			>
				<div
					className="progress-fill"
					style={ {
						width: `${ percentage }%`,
						backgroundColor: fillColor,
					} }
				>
					{ showPercentage && (
						<span
							className="progress-percentage"
							style={ {
								color: percentageTextColor,
								fontSize: `${ percentageFontSize }px`,
								fontFamily: percentageFontFamily,
							} }
						>
							{ percentage }%
						</span>
					) }
				</div>
			</div>
		</div>
	);
}
